import { render, staticRenderFns } from "./Siblings.vue?vue&type=template&id=cf020294&"
import script from "./Siblings.vue?vue&type=script&lang=js&"
export * from "./Siblings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports